/*
 * @Author: Alan
 * @Date: 2023-05-09 18:01:54
 * @LastEditors: Alan
 * @LastEditTime: 2023-07-04 22:29:14
 * @Description: 优惠请求
 * @FilePath: /F1-M2-WEB-Code/actions/promotionRequest.js
 */
import { ApiPort } from "$ACTIONS/TLCAPI";
import { get, post, advpost } from "$ACTIONS/TlcRequest";
import moment from "moment";
import { PromotionList, GetAppliedHistory, GetRebateList } from '../actions/cmsApi';
import { message } from "antd";
import Qs from "qs";

export const enumPromoType = {
    MANUAL_PRE_BONUS: "Manual Pre-Bonus",
    MANUAL_ITEM: "Manual Item",
    RELOAD_BONUS: "Bonus",
};

export const enumVisibility = {
    OFF: "off",
    PUBLIC: "public",
    MEMBER: "member",
};

export const enumPromoActionType = {
    NO_ACTION: "NO_ACTION",
    FUND_IN: "FUND_IN",
    APPLY_FORM: "APPLY_FORM",
    DEPOSIT_PAGE_ONLY: "DEPOSIT_PAGE_ONLY",

    // 2025 start
    NO_FORM: "NO_FORM",
};

//Enum Source: F1 response in https://arcadie.atlassian.net/wiki/spaces/BFF/pages/443285508/GET+api+Bonus+AppliedHistory
export const bonusStatusEnum = {
    AllStatus: 0,
    Pending: 1,
    Cancelled: 2,
    InProgress: 3,
    Processing : 4,
    ForcedToServed : 5,
    Complete : 6,
    ClickToClaim : 7,
    Expired : 8,
    RequiredCheck : 9
};

// bonus history status Enum
export const bonusStatusMapping = {
	inProgress: [ bonusStatusEnum.Pending, bonusStatusEnum.InProgress, bonusStatusEnum.Processing, bonusStatusEnum.RequiredCheck],
	claimable: [bonusStatusEnum.ClickToClaim],
	completed: [bonusStatusEnum.Cancelled, bonusStatusEnum.ForcedToServed, bonusStatusEnum.Expired, bonusStatusEnum.Complete]
};

export const enumBonusGivenType = Object.assign(
    Object.create({
        isMoney: (v) => {
            if (typeof v !== "string") {
                return false;
            }
            v = v.toUpperCase();
            return v.includes("MONEY");
        },
        isRewardsPoint: (v) => {
            if (typeof v !== "string") {
                return false;
            }
            v = v.toUpperCase();
            return v.includes("REWARD") && v.includes("POINT");
        },
        isFreeSpin: (v) => {
            if (typeof v !== "string") {
                return false;
            }
            v = v.toUpperCase();
            return v.includes("FREE") && v.includes("SPIN");
        },
    }),
    {
        MONEY: "Money",
        REWARDS_POINT: "RewardsPoint",
        FREE_SPIN: "FreeSpin",
    }
);

// 取得Promotions資料 （加入本地存储 优化加载速度体验）
export async function getPromotionList() {
    let params = {
        type: 'general',
        transactionType: '',
        wallet: ''
    };
    return PromotionList(params) // 返回一個 Promise
        .then((res)=>{
            console.log('PromotionList resssss ======================= >',res)
            if (res){
                return res
            }
        });
}

/**
 * Enroll Manual Promotion
 * @param {number} actionType 1:CHECK_ELIGIBILITY 在進入Form之前確認是否能提交Form申請 | 2: ENROLL 提交Manual promotion申請
 * @param {object} params 
 * @returns 
 */
export async function manualPromotionEnrollment(actionType, params) {
	try {
		const res = await advpost(ApiPort.POSTCampaignEnrollments + `&actionType=${actionType}`, params);
		return res;
	} catch(error) {
		console.error('manualPromotionEnrollment error:', error);
	}
}

/**
 * @description: 获取优惠的菜单分类 （加入本地存储 优化加载速度体验）
 * @return {*}
 */
export async function getPromotionCategories() {
    let Categories =
        JSON.parse(localStorage.getItem("PromotionCategories")) || [];

    const res = await get(ApiPort.PromotionCategories);

    if (res && res.length != 0) {
        Categories = res || [];

        localStorage.setItem("PromotionCategories", JSON.stringify(Categories));
    }

    return Categories;
}

//取得反水資料
export async function getRebateData(
    startTime = moment(new Date()).format("YYYY-MM-DD"),
    endTime = moment(new Date()).format("YYYY-MM-DD"),
) {
    let params = {
        startDate: startTime,
        endDate: endTime
    };
    console.log('GetRebateList params !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ', params)
    return GetRebateList(params).then((res)=>{
        console.log('GetRebateList res !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ', res)
        if(res){
            return res.result
        }
    })
}

/**
 * @description: 每日好礼 选择收礼地址 申请优惠
 * @return {*}
 */
export function promotionApplication(data, call) {
    post(ApiPort.POSTPromotionApplication, data)
		.then((res) => {
			call(res);
		})
		.catch((error) => {
			console.log('DailyDeals error:', error);
			return null;
		});
}

/**
 * 取得Address基礎資料，ex.省、區、鄉鎮...
 * @param {object} params request query
 * @param {string} param.type Province, District, Town
 * @param {string} param.Id Province Id, District Id
 * @param {function} call 執行callback
 */
export function GetAddressData(params, call = () => {}) {
    get(ApiPort.GETShippingAddressData + "&" + Qs.stringify(params))
        .then((res) => {
            call(res);
        })
        .catch((error) => {
            console.error("GetAddressData error:", error);
            return null;
        });
}
